import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  cardFormContainer: {
    borderRadius: "10px 10px 0 0",
    padding: "28px 8px",
    "@media (min-width: 640px)": {
      backgroundColor: "white",
      padding: "28px 40px",
    },
  },
  inputContainer: {
    paddingTop: 10,
  },
  textLinkBtn: {
    marginTop: "15px",
    marginBottom: "15px",
    display: "block",
    lineHeight: "21px",
    color: theme.palette.events.bluePrimary,
    textDecoration: "underline",
    "&:hover": {
      color: theme.palette.events.bluePrimary,
    },
    padding: "0 2px",
    height: "auto",
    width: "auto",
    backgroundColor: "transparent",
  },
  textLinkText: {
    textTransform: "none",
  },
  nextButton: {
    borderRadius: 25,
    marginTop: "auto",
    fontSize: "16px",
    lineHeight: "24px",
    width: "100%",
  },
}));
